<template>
    <div 
    class="flex flex-col space-y-1 text-gray-800  w-full border-t border-gray-300 my-1">
        <CalculatedCRMSummaryRow 
            v-for="crmAction in currentCampaignActions"
            :key="crmAction.id"
            :crmAction="crmAction"
        />
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import CalculatedCRMSummaryRow from './CalculatedCRMSummaryRow.vue';
import { sortCRMDetailsByResolvedDate as sortByResolvedDate } from '@/composables/CompanyCRMTools';

const props = defineProps(['crmActions', 'currentCampaign'])


const currentCampaignActions = computed(() => {
    if(props.currentCampaign) {
        if(props.crmActions) {
            return props.crmActions.filter(action => {return action.campaign_id == props.currentCampaign}).sort(sortByResolvedDate)
        }
    } 
    return []
})

</script>